//note:should bw shared instance (singleton) to avoid broadcast leaks
export const authChannel = new BroadcastChannel("auth");
